const namespace = 'app/Workspace/Cohorts';

export const SET_COHORT_LIST = `${namespace}/SET_COHORT_LIST`;
export const SET_COHORT_SEARCH_QUERY = `${namespace}/SET_COHORT_SEARCH_QUERY`;
export const SET_COHORT_SORT_DETAILS = `${namespace}/SET_COHORT_SORT_DETAILS`;
export const ADD_COHORT_LIST_ITEM = `${namespace}/ADD_COHORT_LIST_ITEM`;
export const SET_COHORT = `${namespace}/SET_COHORT`;
export const SET_COHORT_COLLABORATORS = `${namespace}/SET_COHORT_COLLABORATORS`;
export const SET_COHORT_ENROLLMENTS = `${namespace}/SET_COHORT_ENROLLMENTS`;
export const ADD_COHORT_ENROLLMENT = `${namespace}/ADD_COHORT_ENROLLMENT`;
export const ARCHIVE_COHORT = `${namespace}/ARCHIVE_COHORT`;
export const SET_DEPLOYMENTS_LIST = `${namespace}/SET_DEPLOYMENTS_LIST`;
export const UPDATE_DEPLOYMENTS_LIST = `${namespace}/UPDATE_DEPLOYMENTS_LIST`;

export const COHORTS_SEARCH_PATH = 'cohortsSearch';
export const COHORTS_SORT_PATH = 'cohortsSort';